import { ITagResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtConnectionId } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { TagRequest } from '../../../TagRequest';

export class DeleteAnalyticsExtConnectionSettingsRequest extends TagRequest<{}, ITagResult> {
  constructor(connectionId: IAnalyticsExtConnectionId) {
    super('analyticsextensions', 'deleteAnalyticsExtensionsConnection', connectionId);
  }
}
